export const scheduleWaiting = {
  'schedule.waiting.title': 'רשימת המתנה',
  'schedule.waiting.action': 'רשימת המתנה',
  'schedule.waiting.new': 'בקשה חדשה',
  'schedule.waiting.edit': 'עריכת בקשה',
  'schedule.waiting.unsaved': 'בקשה לרשימת ההמתנה',
  'schedule.waiting.status': 'סטטוס',
  'schedule.waiting.status.open': 'פתוחה',
  'schedule.waiting.status.booked': 'נקבע תור',
  'schedule.waiting.status.withdrawn': 'בוטלה',
  'schedule.waiting.anyPatient': 'כל המטופלים',
  'schedule.waiting.clinician': 'מטפל מבוקש',
  'schedule.waiting.anyClinician': 'כל מטפל',
  'schedule.waiting.from': 'מתאריך',
  'schedule.waiting.to': 'עד תאריך',
  'schedule.waiting.window': 'מ־{from} עד {to}',
  'schedule.waiting.note': 'העדפות',
  'schedule.waiting.missingInput': 'יש לבחור מטופל, סוג ביקור וימים מתאימים; היום האחרון לא לפני הראשון.',
  'schedule.waiting.create': 'הוספה לרשימת ההמתנה',
  'schedule.waiting.save': 'שמירת הבקשה',
  'schedule.waiting.book': 'קביעת תור',
  'schedule.waiting.withdraw': 'ביטול בקשה',
  'schedule.waiting.withdrawTitle': 'לבטל את הבקשה?',
  'schedule.waiting.withdrawDescription': 'הבקשה נשמרת ברשומה כמבוטלת. אף תור לא משתנה.',
  'schedule.waiting.withdrawConfirm': 'ביטול הבקשה',
  'schedule.waiting.created': 'נוסף לרשימת ההמתנה',
  'schedule.waiting.saved': 'הבקשה נשמרה',
  'schedule.waiting.withdrawn': 'הבקשה בוטלה',
  'schedule.waiting.updated': 'עודכן {time}',
  'schedule.waiting.empty': 'אין בקשות',
  'schedule.waiting.emptyDetail': 'אין בקשות ממתינות לפי הסינון הזה.',
  'schedule.waiting.loading': 'טוען את רשימת ההמתנה',
  'schedule.waiting.loadFailed': 'לא ניתן לטעון את רשימת ההמתנה',
  'schedule.waiting.more': 'הצגת עוד',
  'schedule.sequence.title': 'כמה ביקורים',
  'schedule.sequence.action': 'כמה ביקורים',
  'schedule.sequence.unsaved': 'כמה ביקורים ברצף',
  'schedule.sequence.from': 'היום הראשון',
  'schedule.sequence.span': 'ימים לחיפוש',
  'schedule.sequence.span.day': 'יום אחד',
  'schedule.sequence.span.week': 'שבעה ימים',
  'schedule.sequence.notBefore': 'לא לפני',
  'schedule.sequence.visits': 'ביקורים לפי סדר',
  'schedule.sequence.visit': 'ביקור {n}',
  'schedule.sequence.addVisit': 'הוספת ביקור',
  'schedule.sequence.removeVisit': 'הסרת ביקור {n}',
  'schedule.sequence.moveUp': 'הקדמת ביקור {n}',
  'schedule.sequence.moveDown': 'דחיית ביקור {n}',
  'schedule.sequence.limit': 'עד שמונה ביקורים ברצף אחד, בתוך שבעה ימים.',
  'schedule.sequence.missingInput': 'יש לבחור מטופל, יום ראשון וסוג ביקור לכל ביקור כדי לחפש.',
  'schedule.sequence.search': 'חיפוש זמנים',
  'schedule.sequence.searching': 'מחפש את הביקורים לפי הסדר',
  'schedule.sequence.failed': 'לא ניתן להשלים את החיפוש',
  'schedule.sequence.proposal': 'זמנים מוצעים',
  'schedule.sequence.previewNote': 'הצעה אינה שומרת זמן עד שנקבע תור.',
  'schedule.sequence.incomplete': 'לא נמצא רצף שלם',
  'schedule.sequence.incompleteDetail': 'החיפוש המוגבל לא מצא הצעה שלמה. שנו את הימים, את הסדר או את בחירת המשאבים וחפשו שוב.',
  'schedule.sequence.stale': 'הנתונים השתנו. יש לחפש שוב לפני קביעת התורים.',
  'schedule.sequence.book': 'קביעת כל הביקורים',
  'schedule.sequence.visitFloor': 'ביקור זה לא לפני',
  'schedule.sequence.visitFloorDay': 'ביקור זה לא לפני, יום',
  'schedule.sequence.floorNote': 'זמן התחלה מוקדם ביותר של ביקור מחפש שוב את כל הרצף; הוא והביקורים שאחריו עשויים להידחות כדי לשמור על הסדר.',
  'schedule.sequence.floorInvalid': 'זמן ההתחלה המוקדם ביותר של ביקור חייב להיות שעה הקיימת באזור הזמן של המרפאה, ביום בתוך הימים הנחפשים.',
} as const
